<script lang="ts">
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import mapWorld from "../assets/images/map-world.png?webp&w=1324&imagetools";
	import mapWorldLg from "../assets/images/map-world-lg.png?webp&w=1920&imagetools";
	import mapWorldText from "../assets/images/map-world-text.svg";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./GlobalMap.translations.json";

	const translate = getTranslate(translations);
</script>

<section>
	<div class="bg-secondary relative overflow-hidden">
		<div class="container inset-0 z-10 lg:absolute xl:top-[-7.5rem]">
			<div class="relative flex items-end pt-[7rem] lg:w-[37.5rem] lg:p-[3.75rem] xl:h-[30.75rem] xl:w-[49.125rem]">
				<div class="bg-tertiary absolute inset-0 hidden opacity-80 backdrop-blur-xl lg:block"></div>
				<span class="z-10 text-[2.75rem] font-semibold leading-[1.13] lg:text-[4.625rem]">
					{translate("branoWorld")}
				</span>
			</div>
		</div>
		<div class="top-[14rem] mt-20 w-full max-xl:container lg:top-[27rem] lg:hidden xl:absolute xl:top-0 xl:mt-0">
			<p class="text-md top-[18.7rem] flex flex-col xl:absolute xl:left-[43%] xl:text-end xl:text-[1.1875rem]">
				<span class="flex font-bold">Headquarters <br class="hidden xl:inline-block" /> BRANO GROUP</span>Czech Republic
			</p>
			<p class="text-md top-[20.5rem] flex flex-col xl:absolute xl:left-[29.5%] xl:text-start xl:text-[1.1875rem]">
				<span class="flex font-bold">Office <br class="hidden xl:inline-block" /> BRANO GROUP</span>Detroit, USA
			</p>
			<p class="text-md top-[15rem] flex flex-col xl:absolute xl:left-[60.2%] xl:text-start xl:text-[1.1875rem]">
				<span class="flex font-bold">Production <br class="hidden xl:inline-block" /> BRANORUS</span>Kstovo, Russia
			</p>
			<p
				class="text-md top-[24.5rem] flex flex-col xl:absolute xl:left-[17%] xl:text-end xl:text-[1.1875rem] min-[1800px]:left-[16%] min-[1880px]:left-[18.5%]"
			>
				<span class="flex font-bold">Office <br class="hidden xl:inline-block" /> BRANO GROUP</span>Atlanta, USA
			</p>
			<p class="text-md top-[24.5rem] flex flex-col xl:absolute xl:left-[62.3%] xl:text-end xl:text-[1.1875rem]">
				<span class="flex font-bold">
					Production R&D <br class="hidden xl:inline-block" /> BRANO AUTOMOTIVE PARTS
				</span>Taicang, China
			</p>
			<p
				class="text-md top-[22rem] flex flex-col xl:absolute xl:left-[86%] xl:text-start xl:text-[1.1875rem] min-[1820px]:left-[84%]"
			>
				<span class="flex font-bold">
					Cooperation partner <br class="hidden xl:inline-block" /> OTSUKA KOKI
				</span>Yokohama, Japan
			</p>
		</div>
		<StaticPicture
			image={mapWorld}
			class="absolute top-60 h-[40rem] w-[130%] object-cover lg:hidden"
			imgClass="h-full w-[180%] translate-x-[3rem] translate-y-[-6rem] md:translate-y-[0rem] xl:translate-x-[0rem] xl:w-full object-contain lg:object-contain"
			alt={translate("mapAlt")}
			width={1324}
			height={0}
		/>
		<StaticPicture
			image={mapWorldLg}
			class="absolute top-60 hidden h-full w-full object-cover lg:relative lg:top-0 lg:block lg:object-contain"
			imgClass="h-full w-full h-full object-contain lg:object-contain"
			alt={translate("mapAlt")}
			width={1920}
			height={0}
			imageOver={mapWorldText}
			imageOverFlyIn
		/>
	</div>
</section>
